'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var TablePosition = require('../TablePosition');

/**
 * Normalize position in a table
 * @param {Number} x
 * @param {Number} y
 * @param {Number} width
 * @param {Number} height
 * @return {Array<Number>}
 */
function calculPos(x, y, width, height) {
    if (x < 0) {
        x = width - 1;
        y--;
    }

    if (y < 0) {
        return [-1, -1];
    }

    if (x >= width) {
        x = 0;
        y++;
    }

    if (y >= height) {
        return [-1, -1];
    }

    return [x, y];
}

/**
 * Move selection to an {x,y}
 *
 * @param {Object} opts
 * @param {Slate.Transform} transform
 * @param {Number} x
 * @param {Number} y
 * @param {Boolean} absolute
 * @return {Slate.Transform}
 */
function moveSelection(opts, transform, x, y, xabsolute, yabsolute) {
    var state = transform.state;
    var startBlock = state.startBlock;
    var startOffset = state.startOffset;


    if (startBlock.type !== opts.typeCell) {
        throw new Error('moveSelection can only be applied in a cell');
    }

    var pos = TablePosition.create(state, startBlock);
    var table = pos.table;


    var rowIndex = pos.getRowIndex();
    var colIndex = pos.getColumnIndex();
    var width = pos.getWidth();
    var height = pos.getHeight();

    if (!xabsolute) x += colIndex;
    if (!yabsolute) y += rowIndex;

    var _calculPos = calculPos(x, y, width, height);

    var _calculPos2 = _slicedToArray(_calculPos, 2);

    x = _calculPos2[0];
    y = _calculPos2[1];

    if (x < 0) {
        return transform;
    }

    var row = table.nodes.get(y);
    var cell = row.nodes.get(x);

    // Calcul new offset
    if (startOffset > cell.length) {
        startOffset = cell.length;
    }

    return transform.collapseToEndOf(cell).moveToOffsets(startOffset);
}

module.exports = moveSelection;


//////////////////
// WEBPACK FOOTER
// ./~/slate-edit-table/dist/transforms/moveSelection.js
// module id = 191
// module chunks = 0